import { createContext } from "react";
import { ITestCompletion } from "types/testCompletions";

export interface StatsContextData {
  rawStats?: ITestCompletion[],
}

const StatsContext = createContext<StatsContextData>({} as StatsContextData)

export default StatsContext